var map = {
	"./depNumber.svg": 4928,
	"./frequency.svg": 61078,
	"./fsAmount.svg": 56647,
	"./game.svg": 72145,
	"./hourglass.svg": 69507,
	"./info.svg": 91943,
	"./maxBonus.svg": 38319,
	"./maxCashout.svg": 83170,
	"./maxWinFs.svg": 36981,
	"./minDep.svg": 60327,
	"./prize.svg": 90068,
	"./rtp.svg": 21482,
	"./tick.svg": 80622,
	"./wager.svg": 82795,
	"./wagerDark.svg": 40608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3638;